<script>
    import {Line} from "svelte-chartjs";
      import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    LineElement,
    PointElement,
  } from 'chart.js';

  ChartJS.register(
    Title,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    LineElement,
    PointElement
  );

    import { lineDataset, lineOptions, applyChartDefaults } from "./chartTheme";

    applyChartDefaults();

    export let data = { labels: [], datasets: [] };

    $: styled = {
        ...data,
        datasets: (data.datasets || []).map(lineDataset),
    };
</script>

<div class="chart-box">
    <Line data={styled} options={lineOptions} />
</div>

<style>
    .chart-box {
        position: relative;
        height: 200px;
    }
</style>
